import Vue from 'vue';

// util
import objectIsEmpty from '../../../../util/objectIsEmpty.js';

// components
import MySubscriptions from '../../../../vue/components/template-dashboard/MySubscriptions.vue';

// clients
import SubscriptionClient from '../../../../clients/robox-api/SubscriptionClient.js';

export default () => {
    if (!document.getElementById('vue-my-subscriptions')) return;

    new Vue({
        data: {
            subscriptions: {},
            options: {
                props: {
                    subscriptions: {},
                },
            },
        },
        watch: {
            subscriptions: {
                handler: function (newVal) {
                    this.options.props.subscriptions = newVal;
                },
            },
        },
        created () {
            new SubscriptionClient()
                .index()
                .then((response) => {
                    this.subscriptions = response;
                });
        },
        render (createElement) {
            let options = {};
            Object.assign(options, this.options);

            if (!objectIsEmpty(this.subscriptions)) {
                return createElement(MySubscriptions, options);
            }
        },
    }).$mount('#vue-my-subscriptions');
}



// WEBPACK FOOTER //
// ./scripts/routes/views/partials/dashboard-pages/mySubscriptions.js